import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Mutations {
  createMaintenance(): DocumentNode {
    return gql`
      mutation createMaintenance ($input: MaintenanceCreateInput!) {
        createMaintenance (input: $input) {
          id
        }
      }
    `;
  }

  updateMaintenance(): DocumentNode {
    return gql`
      mutation updateMaintenance($id: ID!, $input: MaintenanceUpdateInput!) {
        updateMaintenance(id: $id, input: $input) {
          id
        }
      }
    `;
  }

  reallocateMaintenance(): DocumentNode {
    return gql`
      mutation reallocateMaintenance($id: ID!, $input: ReallocateMaintenanceInput!) {
        reallocateMaintenance(id: $id, input: $input) {
          id
        }
      }
    `;
  }

  cancelMaintenance(): DocumentNode {
    return gql`
      mutation cancelMaintenance($id: ID!, $input: CancelMaintenanceInput!) {
        cancelMaintenance(id: $id, input: $input) {
          id
        }
      }
    `;
  }

  archiveMaintenance(): DocumentNode {
    return gql`
      mutation archiveMaintenance($id: ID!) {
        archiveMaintenance(id: $id) {
          id
          archived
        }
      }
    `;
  }
  unarchiveMaintenance(): DocumentNode {
    return gql`
      mutation unarchiveMaintenance($id: ID!) {
        unarchiveMaintenance(id: $id) {
          id
          archived
        }
      }
    `;
  }

  createMaintenanceComment(): DocumentNode {
    return gql`
      mutation createMaintenanceComment($input: CommentInput!) {
        createMaintenanceComment(input: $input) {
          id
          message
          createdAt
          type
          archived
          postedBy {
            id
            name
            avatarUrl
            type
          }
        }
      }
    `;
  }

  removeMaintenanceComment(): DocumentNode {
    return gql`
      mutation removeMaintenanceComment($id: ID!) {
        removeMaintenanceComment(id: $id) {
          id
        }
      }
    `;
  }

  removeMaintenanceLabel(): DocumentNode {
    return gql`
      mutation removeMaintenanceLabel($maintenanceId: ID!, $labelId: ID!) {
        removeMaintenanceLabel(maintenanceId: $maintenanceId, labelId: $labelId) {
          id
        }
      }
    `;
  }

  addMaintenanceLabel(): DocumentNode {
    return gql`
      mutation createMaintenanceLabels($input: [MaintenanceLabelCreateInput]!) {
        createMaintenanceLabels(input: $input) {
          id
        }
      }
    `;
  }

  reopenMaintenance(): DocumentNode {
    return gql`
      mutation reopenMaintenance($id: ID!, $input: ReopenMaintenanceInput!) {
        reopenMaintenance(id: $id, input: $input) {
          id
        }
      }
    `;
  }

  cancelMaintenanceScheduleSuggestions(): DocumentNode {
    return gql`
      mutation cancelMaintenanceScheduleSuggestions($id: ID!) {
        cancelMaintenanceScheduleSuggestions(id: $id) {
          id
        }
      }
    `;
  }

  acceptMaintenanceScheduleSuggestions(): DocumentNode {
    return gql `
      mutation acceptMaintenanceScheduleSuggestions($id: ID!) {
        acceptMaintenanceScheduleSuggestions(id: $id) {
          id
        }
      }
    `;
  }

  updateMaintenanceScheduleSuggestions(): DocumentNode {
    return gql `
      mutation updateMaintenanceScheduleSuggestions($id: ID!, $suggestions: [MaintenanceScheduleSuggestionInput!]!) {
        updateMaintenanceScheduleSuggestions(id: $id, suggestions: $suggestions) {
          id
          scheduleSuggestions {
            date
            time
          }
        }
      }
    `;
  }
}
